var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandpredictorMediumDe2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2266,
    height: 2088,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1028,
    y: 264,
    width: 2266,
    height: 2088
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1028 -264)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1280.9 2164)"
  }, "-100")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1299.49 1934)"
  }, "-75")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1299.49 1704)"
  }, "-50")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1299.49 1474)"
  }, "-25")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1329.3 1244)"
  }, "0")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1310.72 1015)"
  }, "25")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1310.72 785)"
  }, "50")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1310.72 555)"
  }, "75")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1292.13 325)"
  }, "100")), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(-1.83697e-16 -1 1 -1.83697e-16 3115.67 1373)"
  }, "STRONG TRUST"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 55,
    transform: "matrix(1 0 0 1 1710.52 382)"
  }, "HIGH DYNAMISM"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 55,
    transform: "matrix(1 0 0 1 1722.78 2115)"
  }, "LOW DYNAMISM"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 55,
    transform: "matrix(-1.83697e-16 -1 1 -1.83697e-16 1453.67 1346)"
  }, "WEAK TRUST"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 69,
    transform: "matrix(1 0 0 1 1493.97 725)"
  }, "EMERGING "), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 69,
    transform: "matrix(1 0 0 1 1533.48 808)"
  }, "BRANDS"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 69,
    transform: "matrix(1 0 0 1 2352.39 787)"
  }, "STAR BRANDS"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 69,
    transform: "matrix(1 0 0 1 1512.54 1541)"
  }, "SLEEPING "), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 69,
    transform: "matrix(1 0 0 1 1530.6 1624)"
  }, "BRANDS"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 69,
    transform: "matrix(1 0 0 1 2286.99 1578)"
  }, "FADING BRANDS"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1401.81 893)"
  }, "Aufgabe: Vertrauen gewinnen"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2252.79 901)"
  }, "Aufgabe: Leader"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2526.65 901)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2539.25 901)"
  }, "Position festigen"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1521.23 1707)"
  }, "Aufgabe: (Re"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1736.65 1707)"
  }, "-"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1749.25 1707)"
  }, ") "), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 1536.7 1756)"
  }, "Vitalisierung"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2341.21 1708)"
  }, "Aufgabe: Innovation"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1284.11 2275)"
  }, "* Die Trennlinien f\xFCr Dynamik (6.5) und Vertrauen (19.5) basieren auf den h\xE4ufigsten Werten in der Verteilung "), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 2936.4 2275)"
  }, "\u2013"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 2962.76 2275)"
  }, "also dort, wo "), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1284.11 2319)"
  }, "die meisten Marken liegen. So spiegeln die Quadranten die tats\xE4chliche Marktlage m\xF6glichst differenziert wider."), /*#__PURE__*/React.createElement("path", {
    d: "M1911.5 412.5 1911.5 2049.51",
    stroke: "#A6A6A6",
    strokeWidth: 1.14583,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490 1189 3049.06 1189",
    stroke: "#A6A6A6",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 50,
    transform: "matrix(1 0 0 1 1939.09 1975)"
  }, "19.5*"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 50,
    transform: "matrix(1 0 0 1 1495.82 1165)"
  }, "6.5*"), /*#__PURE__*/React.createElement("path", {
    d: "M1375.5 309.5 1375.5 2154.38",
    stroke: "#A6A6A6",
    strokeWidth: 1.14583,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3159.5 311.5 3159.5 2156.38",
    stroke: "#A6A6A6",
    strokeWidth: 1.14583,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.5 305.5 3113.48 305.5",
    stroke: "#A6A6A6",
    strokeWidth: 1.14583,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.5 2155.5 3115.48 2155.5",
    stroke: "#A6A6A6",
    strokeWidth: 1.14583,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 3061.91 2214)"
  }, "100"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 2662.04 2214)"
  }, "75"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 2253.01 2214)"
  }, "50"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1843.97 2214)"
  }, "25"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 37,
    transform: "matrix(1 0 0 1 1444.1 2214)"
  }, "0"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandpredictorMediumDe2);
export default __webpack_public_path__ + "static/media/brandpredictor_medium_de_2.ab4525e8b9495bd55608c072271f30ce.svg";
export { ForwardRef as ReactComponent };